import { render, staticRenderFns } from "./movements.vue?vue&type=template&id=2e4d85d0"
import script from "./movements.vue?vue&type=script&lang=js"
export * from "./movements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports